import React from 'react';
import { Plus } from 'lucide-react';
import Reveal from '../home/Reveal';

interface Question {
  q: string;
  a: string;
  bullets?: string[];
}

interface QuestionsAnsweredProps {
  questions: Question[];
  dark?: boolean;
}

const QuestionsAnswered: React.FC<QuestionsAnsweredProps> = ({ questions, dark = true }) => {
  if (questions.length === 0) return null;

  return (
    <section className={`py-16 md:py-20 px-6 border-t ${dark ? 'bg-black text-white border-white/10' : 'bg-white text-black border-black/10'}`}>
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[2fr_3fr] gap-10 lg:gap-20 items-start">
        <Reveal>
          <h2 className="font-montserrat font-extrabold tracking-[-0.03em] leading-[1.05] text-[clamp(30px,3.4vw,44px)]">
            Questions, answered
          </h2>
        </Reveal>
        <Reveal delay={100}>
          <div className={`divide-y border-y ${dark ? 'divide-white/10 border-white/10' : 'divide-black/10 border-black/10'}`}>
            {questions.map((question) => (
              <details key={question.q} className="group">
                <summary className="flex items-center justify-between gap-6 py-5 cursor-pointer list-none font-montserrat font-bold text-base md:text-lg [&::-webkit-details-marker]:hidden">
                  {question.q}
                  <Plus aria-hidden="true" className={`shrink-0 w-5 h-5 transition-transform duration-500 group-open:rotate-45 group-open:text-[#78BE20] ${dark ? 'text-white/40' : 'text-black/40'}`} />
                </summary>
                <div className="pb-6">
                  <p className={`font-poppins text-sm md:text-base leading-7 max-w-xl ${dark ? 'text-white/70' : 'text-black/70'}`}>
                    {question.a}
                  </p>
                  {question.bullets && (
                    <ul className="mt-3 space-y-1.5 max-w-xl">
                      {question.bullets.map((bullet) => (
                        <li key={bullet} className={`font-poppins text-sm leading-6 flex gap-2 ${dark ? 'text-white/60' : 'text-black/60'}`}>
                          <span className="text-[#78BE20]">–</span>
                          {bullet}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </details>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default QuestionsAnswered;
